var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "guide-icon-1_svg__a",
    d: "M0 0h37.332v37.332H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "guide-icon-1_svg__c",
    d: "M0 40h42.655V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.323 2.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "guide-icon-1_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#guide-icon-1_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.332 18.666c0 10.309-8.357 18.666-18.666 18.666C8.357 37.332 0 28.975 0 18.666 0 8.357 8.357 0 18.666 0c10.309 0 18.666 8.357 18.666 18.666",
    fill: "#F8D7CC",
    mask: "url(#guide-icon-1_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "guide-icon-1_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#guide-icon-1_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#guide-icon-1_svg__d)",
    d: "M16.092 8.114h2.871V.934h-2.871z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.81 7.396h1.435V1.653H16.81v5.743zm-1.436 1.436h4.307V.217h-4.307v8.615z",
    fill: "#020303",
    mask: "url(#guide-icon-1_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#guide-icon-1_svg__d)",
    d: "M23.989 3.806l-8.615 7.18V23.19h17.23V10.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#guide-icon-1_svg__d)",
    d: "M21.835 22.473h4.308V16.01h-4.308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.553 21.755h2.872v-5.026h-2.872v5.026zm-1.436 1.435h5.744v-7.897h-5.744v7.897z",
    fill: "#020303",
    mask: "url(#guide-icon-1_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.439 21.268l-4.223 2.003-.231.087a1.67 1.67 0 00-1.52-.886h-4.307c-.987 0-2.488-1.435-3.677-1.435h-4.22c-1.735 0-3.285 1.42-4.16 2.234-1.349 1.35-4.06 4.075-4.06 4.075l6.6 6.606c1.078-1.078 2.348-2.146 3.45-2.146h8.616c1.344 0 2.682-.413 3.634-1.364l7.144-7.144 2.03-5.076c-1.238-1.238-4.061.084-5.076 3.046",
    fill: "#FEFEFE",
    mask: "url(#guide-icon-1_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.054 27.345l5.595 5.6c1.013-.948 2.236-1.857 3.443-1.857h8.615c1.272 0 2.382-.41 3.126-1.154l7.04-7.04 1.752-4.382a1.46 1.46 0 00-.693.013c-.97.224-2.217 1.232-2.815 2.975l-.097.287-4.114 1.951c.071.28.108.582.108.902 0 1.689-1.048 2.858-2.548 2.858h-7.503a.718.718 0 110-1.436h7.503c1.032 0 1.113-1.078 1.113-1.408 0-.255-.054-1.464-1.113-1.464h-4.308c-.656 0-1.32-.368-2.02-.758-.573-.317-1.221-.677-1.657-.677h-4.22c-1.478 0-2.904 1.328-3.67 2.041-.974.975-2.688 2.697-3.537 3.55zm5.586 7.623l-7.613-7.621.505-.507s2.713-2.726 4.063-4.077c.928-.866 2.622-2.444 4.666-2.444h4.22c.808 0 1.594.436 2.353.858.488.27 1.04.578 1.324.578h4.308c.706 0 1.313.262 1.756.718l3.644-1.728c.725-1.85 2.168-3.255 3.743-3.619.94-.22 1.822-.003 2.414.588l.335.335-2.261 5.652-7.25 7.249c-1.014 1.015-2.485 1.574-4.14 1.574h-8.615c-.669 0-1.66.65-2.944 1.936l-.508.508z",
    fill: "#020303",
    mask: "url(#guide-icon-1_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#guide-icon-1_svg__d)",
    d: "M5.323 25.344l-4.308 4.308 9.333 9.333 4.307-4.308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03 29.652l8.318 8.318 3.292-3.293-8.317-8.318-3.293 3.293zM10.348 40L0 29.652l5.323-5.323L15.67 34.677 10.348 40z",
    fill: "#020303",
    mask: "url(#guide-icon-1_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#guide-icon-1_svg__d)",
    d: "M5.928 31.2l-1.435-1.436 1.015-1.015 1.436 1.436zm25.958-10.163h1.436V10.986h-1.436zm-17.23 0h1.436V10.986h-1.436z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#guide-icon-1_svg__d)",
    d: "M23.989.935L11.066 11.704l2.154 2.153 10.769-8.615 10.769 8.615 2.154-2.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.989 4.323l10.716 8.572 1.143-1.143-11.86-9.883-11.859 9.883 1.144 1.143L23.99 4.323zM34.81 14.82L23.989 6.162l-10.822 8.657-3.164-3.164L23.989.001l13.986 11.654-3.164 3.164z",
    fill: "#020303",
    mask: "url(#guide-icon-1_svg__d)"
  }))));
}
export default SvgGuideIcon1;